import { render, staticRenderFns } from "./Eventos-Listagem.vue?vue&type=template&id=3aebd1a6&"
import script from "./Eventos-Listagem.vue?vue&type=script&lang=js&"
export * from "./Eventos-Listagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Eventos-Listagem.vue"
export default component.exports